import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section, SectionHeading } from './Shared';
import { featuredTestimonial, testimonials, type Testimonial } from '../data/testimonials';
export function TestimonialCard({
  initials,
  name,
  location,
  product,
  text
}: Testimonial) {
  return <article className="paper-card flex h-full flex-col rounded-sm border border-brand-gold/40 p-6 shadow-[0_10px_28px_rgba(44,38,32,0.07)] md:p-7" data-id="element-290" data-mp="3b1cj58dt8wi3">
      <div className="mb-4 flex items-center gap-3" data-id="element-291" data-mp="36wwgrh3eo77m">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-sm border border-brand-gold/55 bg-brand-surfaceLight font-serif font-bold text-brand-forest" data-id="element-292" data-mp="31yuxav22i5vm">
          {initials}
        </div>
        <div data-id="element-293" data-mp="2s308tjb5xgkx">
          <div className="flex text-brand-gold" aria-label="5 de 5 estrellas" data-id="element-294" data-mp="2s3jh08b0gqlr">
            {Array.from({
            length: 5
          }, (_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-295" data-mp="qb51tgzuq091" />)}
          </div>
          <p className="mt-1 font-semibold text-brand-ink" data-id="element-296" data-mp="m2ydkm9tg9t5">{name}</p>
          <p className="text-xs text-brand-muted" data-id="element-297" data-mp="7928cw8yjxa5">
            {location} · {product}
          </p>
        </div>
      </div>
      <p className="font-display text-base leading-relaxed text-brand-text md:text-lg" data-id="element-298" data-mp="c73phbmtpmiz">
        “{text}”
      </p>
    </article>;
}
export function InitialTestimonials() {
  return <Section className="pt-6" data-id="element-299" data-mp="14uzlee4kjaep">
      <div className="mx-auto max-w-3xl" data-id="element-300" data-mp="14xdckbw4o2gz">
        <TestimonialCard {...featuredTestimonial} data-id="element-301" data-mp="q7ef6bcecv2k" />
      </div>
    </Section>;
}
export function MoreTestimonials() {
  return <Section data-id="element-302" data-mp="v3wkbcbn2vff">
      <SectionHeading character="證" className="mb-10" data-id="element-303" data-mp="v3mr7fvas85i">
        LO QUE DICEN LOS TERAPEUTAS QUE YA LO TIENEN
      </SectionHeading>
      <div className="mx-auto grid max-w-4xl grid-cols-1 gap-6 md:grid-cols-2" data-id="element-304" data-mp="1nlqt7b8wqsqz">
        {testimonials.map(testimonial => <TestimonialCard key={testimonial.initials} {...testimonial} data-id="element-305" data-mp="1xgxv8z0chnh5" />)}
      </div>
    </Section>;
}